import { render, staticRenderFns } from "./OrganizationHistory.vue?vue&type=template&id=4edde4da&"
import script from "./OrganizationHistory.vue?vue&type=script&lang=ts&"
export * from "./OrganizationHistory.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports